import React from "react";

import { formatDateOnly } from "../../../../../utils/datetime";
import { availabilityLabel } from "../../utils/listingHelpers";
import { buildListingPreviewModel } from "../../utils/listingPreview";
import ListingFieldGroup from "../components/ListingFieldGroup";
import ListingPreviewCard from "../components/ListingPreviewCard";

/**
 * "Vorschau": how the listing reads as a card, from the editor's own state.
 *
 * Entirely local. It derives everything from the form the user is currently
 * editing, so it shows unsaved changes immediately and works before a new
 * listing has ever been saved — no id, no slug, no request, not even a read.
 *
 * It is a rehearsal of the list view, not a rendering of the live site. The
 * production marketing site is a separate deployment with its own components,
 * so this panel says so in its own words rather than implying byte-accuracy.
 * For the same reason there is no "open on the website" link here: this app
 * has no configured base URL for that deployment, and a relative link would
 * point at the in-repo copy and show something else again.
 *
 * The status block below the card is admin metadata, kept visually apart from
 * the card so nobody reads the publication state as part of the listing.
 */

function StatusRow({ label, children }) {
  return (
    <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 border-b border-border py-2 last:border-0">
      <dt className="text-[13px] text-muted-foreground">{label}</dt>
      <dd className="m-0 text-[13px] font-medium text-foreground">{children}</dd>
    </div>
  );
}

export default function ListingPreviewSection({
  form,
  cities,
  images,
  availabilityStatus,
}) {
  const model = buildListingPreviewModel({ form, cities, images });

  return (
    <>
      <ListingFieldGroup
        title="Listendarstellung"
        description="Lokale Vorschau aus dem aktuellen Formular, inklusive noch nicht gespeicherter Änderungen. Sie zeigt die deutsche Fassung; die Website kann gestalterisch abweichen."
      >
        <ListingPreviewCard model={model} />
        {model.imageUrl ? null : (
          <p className="m-0 text-[12px] text-muted-foreground">
            Bilder erscheinen hier, sobald sie unterhalb des Formulars
            hochgeladen sind.
          </p>
        )}
      </ListingFieldGroup>

      <ListingFieldGroup
        title="Status"
        description="Nur zur Information — diese Angaben sind nicht Teil der Karte oben."
      >
        <dl className="m-0">
          <StatusRow label="Veröffentlichung">
            {form.is_published ? "Online" : "Offline"}
          </StatusRow>
          <StatusRow label="Verfügbarkeit">
            {availabilityLabel(availabilityStatus)}
          </StatusRow>
          <StatusRow label="Verfügbar ab">
            {form.available_from
              ? formatDateOnly(form.available_from)
              : "Sofort verfügbar"}
          </StatusRow>
        </dl>
      </ListingFieldGroup>
    </>
  );
}
